module.exports = __webpack_public_path__ + "img/products_big_can_tropical.09cf0d7c.png";